import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { CalendarRange, Play, Shuffle, Users, ArrowRight, FlaskConical, Briefcase } from "lucide-react";

const CARDS = [
  { to: "/director/agenda", icon: CalendarRange, title: "Agenda Library", body: "Browse Level → Session → Class and open any agenda to run it live." },
  { to: "/director/generator", icon: Shuffle, title: "Spin For A Prompt", body: "The Promptinator — spin prompts with a wheel animation — on your device or full-screen Projector Mode." },
  { to: "/director/frankenstein", icon: FlaskConical, title: "Dr. Frankenstein", body: "Build a wild character — spin a Character, a physical move, a voice, and a prop." },
  { to: "/director/rosters", icon: Users, title: "My Rosters", body: "See the classes assigned to you, open each roster, and take attendance." },
  { to: "/director/toolbox", icon: Briefcase, title: "Director Tool Box", body: "Evaluations, incident report form, cheat sheets and promotion templates." },
];

export default function DirectorDashboard() {
  const { user } = useAuth();
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-testid="director-dashboard">
      <span className="text-xs uppercase tracking-[0.22em] font-extrabold text-[#920e12]">Director Console</span>
      <h1 className="mt-2 font-display text-4xl text-[#550001]">Welcome, {user?.name?.split(" ")[0]}</h1>
      <p className="mt-2 text-[#545454]">Run classes, draw prompts, and manage your rosters — all in one place.</p>

      <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-6">
        {CARDS.map((c) => (
          <Link key={c.to} to={c.to} data-testid={`director-card-${c.title.toLowerCase().replace(/\s/g, "-")}`}
            className="group bg-white rounded-3xl border border-[#dfd8da] p-8 hover:border-[#920e12] transition-colors duration-150">
            <div className="w-14 h-14 rounded-2xl bg-[#920e12] text-white flex items-center justify-center">
              <c.icon size={26} aria-hidden="true" />
            </div>
            <h2 className="mt-5 text-2xl font-bold text-[#1a1617] group-hover:text-[#920e12] flex items-center gap-2">
              {c.title} <ArrowRight size={20} className="opacity-0 group-hover:opacity-100 transition-opacity" />
            </h2>
            <p className="mt-2 text-[#545454]">{c.body}</p>
          </Link>
        ))}
      </div>

      <div className="mt-8 bg-[#221517] text-[#dfd8da] rounded-3xl p-8 border-l-4 border-[#bf6163] flex items-start gap-4">
        <Play className="text-[#bf6163] shrink-0 mt-1" aria-hidden="true" />
        <div>
          <h2 className="text-white text-xl font-bold">Class Runner</h2>
          <p className="mt-1 text-sm">Open the Agenda Library and hit <strong>Run</strong> on any class to enter the full-screen, large-type projector cockpit. Keyboard: <kbd className="px-1.5 py-0.5 bg-[#3c2225] rounded">Space/N</kbd> next, <kbd className="px-1.5 py-0.5 bg-[#3c2225] rounded">P</kbd> prev, <kbd className="px-1.5 py-0.5 bg-[#3c2225] rounded">T</kbd> timer, <kbd className="px-1.5 py-0.5 bg-[#3c2225] rounded">F</kbd> full projector, <kbd className="px-1.5 py-0.5 bg-[#3c2225] rounded">Esc</kbd> exit.</p>
        </div>
      </div>
    </div>
  );
}
